import React, { Component } from 'react';
import PropTypes from 'prop-types';


//import classNames from 'classnames';
import List from '@mui/material/List';
//import Assessment from '@mui/icons-material/Assessment';
import DashIcon from '@mui/icons-material/Assessment';
import MapIcon from '@mui/icons-material/LocationOn';
import MemberIcon from '@mui/icons-material/Group';
import PermIdentity from '@mui/icons-material/PermIdentity';
import { Home,WarningAmber,Devices } from '@mui/icons-material';
import DynamicMenuParent from './DynamicMenuParent';
import DynamicMenuChild from './DynamicMenuChild';
import DynamicMenuItem from './DynamicMenuItem';
import { Box } from '@mui/material';

const s:any = {
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: 'background.paper',
  },
};

class DynamicMenu extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count:0
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.page !== nextProps.page) {
  //       this.setState({page: nextProps.page});
  //   }
  // }

  handleClick = (name:any) => (event:any,value:any) => {
    console.log('dynamic handleclick:',name,event,value);
    this.setState({activeId:name});
  }

  mkKey = (k:any,n:any) => k+n.toLocaleString('en', {minimumIntegerDigits:3});

  toArray(o:any){
    Object.keys(o).reduce(function(out:any, key:any) {
      out.push({
        key: key,
        value: o[key]
      });
      return out;
    }, []);
  }

  mkMenus = (mns:any,handleClick:Function) => {
    var mnu,mnlist,mnkey,mni,smn,smtitle,smaction,smlist,smi,smkey;
    const dash = {key:'DASHBOARD',title:'Dashboard',icon:<DashIcon/>,action:'dashboard'};
    const house = {key:'HOUSE',title:'Houses',icon:<Home/>,action:'house'};
    const device = {key:'DEVICE',title:'Devices',icon:<Devices/>,action:'device'};
    const issue = {key:'ISSUE',title:'Issues',icon:<WarningAmber/>,action:'issue'};
    // const logout = {key:'LOGOUT',title:'Logout',icon:<PermIdentity/>,action:'logout'};

    const houseone = {key:'HSONE',title:'Houses 1',action:'houseone'};

    mnlist = [
      (<DynamicMenuItem index={10} key={dash.key} title={dash.title} icon={dash.icon} divider action={dash.action} activeid={this.state.activeId} onClick={handleClick} />),
      (<DynamicMenuParent index={20} key={house.key} title={house.title} icon={house.icon} divider activeid={this.state.activeId} onClick={this.handleClick}>
        <DynamicMenuChild index={12} key={houseone.key} title={houseone.title} action={houseone.action} activeid={this.state.activeId} onClick={handleClick} />
      </DynamicMenuParent>),
      (<DynamicMenuItem index={30} key={device.key} title={device.title} icon={device.icon} divider action={device.action} activeid={this.state.activeId} onClick={handleClick} />),
      (<DynamicMenuItem index={40} key={issue.key} title={issue.title} icon={issue.icon} divider action={issue.action} activeid={this.state.activeId} onClick={handleClick} />)
    ];
    //mni=0;
    mni=mnlist.length+1;
    // for(var key in mns){
    //   // console.log('mns.key',key);
    //   if(!key || key === 'undefined') continue;
    //   mnu = mns[key];
    //   smn = mnu.smn;
    //   smlist = [];
    //   smi = 1;
    //   for(smtitle in smn){ 
    //     smaction = smn[smtitle];
    //     smkey = this.mkKey(key,smi);
    //     smlist.push((<DynamicMenuChild index={mni*10+smi} key={smkey} title={smtitle.replace(/^Manage\s+/,'')} action={smaction} activeid={this.state.activeId} onClick={handleClick} />)); //onclick
    //     smi++;
    //   }
    //   mnkey = this.mkKey(key,0);
    //   mnlist.push(
    //     (
    //       <DynamicMenuParent index={mni*10} key={mnkey} title={mnu.nam.replace(/ .*/,'')} divider activeid={this.state.activeId} onClick={this.handleClick}> 
    //         {smlist.map((smitem) =>
    //           smitem 
    //         )}
    //       </DynamicMenuParent>
    //     )
    //   );
    //   mni++;
    // }
    
    return mnlist;
  }

  render() {
    const {data, handleClick, classes} = this.props;
    const mns = data.mn||{};
    const dynmenus = this.mkMenus(mns,handleClick);
    return (
      <Box sx={{...s.root}}>
        <List component="nav">
          {dynmenus}
        </List>
      </Box>
    );
  }
}

DynamicMenu.propTypes = {
  data: PropTypes.object.isRequired,
  handleClick: PropTypes.func
};

export default DynamicMenu;
//export default DynamicMenu;
